module.exports = __webpack_public_path__ + "mobile_app_loanchat_qr_code_ios.70a7a2d.png";